const productColorSwitch = () => {
  const colorChange = e => {
    e.stopPropagation();

    const target = e.currentTarget;
    const href = target.getAttribute('data-href');
    const productCard = target.closest('.product-card');
    const clickIndex = Array.from(target.parentNode.children).indexOf(target);

    // 移除兄弟元素的 active class 並為當前元素添加 active class
    Array.from(target.parentNode.children).forEach(sibling => sibling.classList.remove('active'));
    target.classList.add('active');

    // 更新 color-box 的 active class
    const colorBoxes = productCard.querySelectorAll('.color-box');
    colorBoxes.forEach(box => box.classList.remove('active'));
    if (colorBoxes[clickIndex]) {
      colorBoxes[clickIndex].classList.add('active');
    }

    // 更新產品連結的 href
    const productLink = productCard.querySelector('a');
    if (productLink) {
      productLink.setAttribute('href', href);
    }
  };

  const colorChips = document.querySelectorAll('.product-card .color-chips > li');
  colorChips.forEach(chip => {
    chip.addEventListener('click', colorChange);
  });
};

export default productColorSwitch;
